import { render, staticRenderFns } from "./RasConfigurazioneLaboratorioRepartoViewComponent.vue?vue&type=template&id=26ec805d"
import script from "./RasConfigurazioneLaboratorioRepartoViewComponent.vue?vue&type=script&lang=js"
export * from "./RasConfigurazioneLaboratorioRepartoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports